import { Header } from "/components/Header/Header";
import { Projects } from "/components/ProjectsPage/Projects";

export const ProjectsPage = () => {
  return (
    <>
      <Header />
      <main>
        <Projects />
      </main>
    </>
  );
};
